import initSpangleDesignInspirations from "components/jiffy/spangle-design-inspirations/spangle-design-inspirations";

document.addEventListener("DOMContentLoaded", initSpangleDesignInspirations);
